import { LinkSection } from "components/pages/frontpage";

const MainPage = () => {
  return (
    <div className="tw-mt-xxl">
      <LinkSection />
    </div>
  );
};

export default MainPage;
